module.exports = __webpack_public_path__ + "static/media/galerierudigerschottle.3ddf7188.svg";